import MixpanelEventClass from "common/utils/ui/mixpanel-event-class";
import "./digital-assets-selected-filters.scss";

export default () =>
  new MixpanelEventClass({
    eventSelector: ".js-asset-remove-pill",
    mixpanelEventOptions: {
      eventName: "digital_asset_pill_removed"
    },
    attributesToContext: {
      filterName: "filter_name",
      filterValue: "filter_value",
      activeFilters: "active_filters",
      resultCount: "result_count",
      pageName: "page_name"
    }
  });
